/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationCandidateProfileSettingsUpdate } from '../../axios/organisationCandidateProfileSettingsUpdate'
import type {
	OrganisationCandidateProfileSettingsUpdateError,
	OrganisationCandidateProfileSettingsUpdatePathParams,
	OrganisationCandidateProfileSettingsUpdateRequest,
	OrganisationCandidateProfileSettingsUpdateResponse,
} from '../../types/OrganisationCandidateProfileSettingsUpdate'

export const organisationCandidateProfileSettingsUpdateMutationKey = () =>
	[{ url: '/organisations/:organisation/candidate-profile-settings' }] as const

export type OrganisationCandidateProfileSettingsUpdateMutationKey = ReturnType<
	typeof organisationCandidateProfileSettingsUpdateMutationKey
>

export type OrganisationCandidateProfileSettingsUpdateVariables = {
	organisation: OrganisationCandidateProfileSettingsUpdatePathParams['organisation']
	data: OrganisationCandidateProfileSettingsUpdateRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationCandidateProfileSettingsController.php OrganisationCandidateProfileSettingsController::update */
export function useOrganisationCandidateProfileSettingsUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationCandidateProfileSettingsUpdateResponse,
		AxiosError<OrganisationCandidateProfileSettingsUpdateError>,
		OrganisationCandidateProfileSettingsUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationCandidateProfileSettingsUpdateMutationKey(),
		mutationFn: ({ organisation, data }: OrganisationCandidateProfileSettingsUpdateVariables) =>
			organisationCandidateProfileSettingsUpdate(organisation, data, config).then(res => res.data),
		...options,
	})
}
